import * as React from "react"
import {graphql, Link, useStaticQuery} from 'gatsby'

export default function Menu() {
    const data = useStaticQuery(graphql`
{
  allPrismicMenuItems {
    edges {
      node {
        data {
          body {
            ... on PrismicMenuItemsDataBodyNavigation {
              primary {
                label
                lien
              }
            }
          }
        }
      }
    }
  }
}
`)

    if (!data) return undefined
    const menuItems = data?.allPrismicMenuItems?.edges[0]?.node?.data?.body?.map(
        edge => ({type: edge.primary?.lien, label: edge.primary?.label}));

    return menuItems.map(menuItem => (
        <div className="navbar-item" key={menuItem?.type}>
            <Link to={`/${menuItem?.type}`}>{menuItem?.label}</Link>
        </div>
    ))
}
